import React, { useEffect, useState, createContext } from "react";
import { Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Home from "./component/Home/Home/Home";
import About from "./component/Home/About/About";
import Dashboard from "./component/Dashoboard/Dashboard/Dashboard";
import LoginModal from "./component/Login/LoginModal";
import PrivateRoute from "./component/Login/PrivateRoute";
import NotFound from "./component/NotFound";

export const UserContext = createContext();

const App = () => {

  const [showLogin, setShowLogin] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      const user = localStorage.getItem("user");
      if (!user) {
        setShowLogin(true);
      }
    }, 30000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div>

      {/* TOAST */}
      <Toaster position="top-right" reverseOrder={false} />

      {/* AUTO LOGIN POPUP */}
      {showLogin && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100vh",
            background: "rgba(0,0,0,0.6)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",   /* centered — no top padding */
            boxSizing: "border-box",
            overflow: "hidden",
          }}
          onClick={(e) => {
            if (e.target === e.currentTarget) setShowLogin(false);
          }}
        >
          <div
            style={{
              width: "90%",
              maxWidth: "1000px",
              background: "#fff",
              borderRadius: "15px",
              overflow: "hidden",
              position: "relative",
              /* removed marginBottom */
            }}
          >
            {/* CANCEL BUTTON */}
            <button
              onClick={() => setShowLogin(false)}
              style={{
                position: "absolute",
                top: "10px",
                right: "15px",
                border: "none",
                background: "transparent",
                fontSize: "28px",
                cursor: "pointer",
                zIndex: 10,
                lineHeight: 1,
                color: "#555",
              }}
              aria-label="Close login popup"
            >
              ×
            </button>

            <LoginModal />
          </div>
        </div>
      )}

      {/* ROUTES */}
      <Routes>
        <Route path="/"           element={<Home />} />
        <Route path="/about"      element={<About />} />
        <Route path="/login"      element={<LoginModal />} />
        <Route
          path="/dashboard/*"
          element={
            <PrivateRoute redirectTo="/login">
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>

    </div>
  );
};

export default App;